import api from '../../../App/socket';

export const changeBikeModelVariants = (variant_id, key, value) => {
    const updateHotCold = {};

    if (key === 'is_hot' && value === true) {
        updateHotCold.is_no_buy = false;
    } else if (key === 'is_no_buy' && value === true) {
        updateHotCold.is_hot = false;
    }

    return api.send({
        api: 'db',
        model: 'Bike_variant',
        action: 'Update',
        options: {
            where: {
                _id: variant_id,
            },
            update: {
                [key]: value,
                ...updateHotCold,
            },
        },
    }).then(response => response).catch(error => error);
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/requests/change_bike_variants_request.js